import Request from 'api'

export const types = {
  setError: `SET_ERROR`,
  setFormData: `SET_FORM_DATA`,
  setInputValue: `SET_INPUT_VALUE`,
  changePromotion: `CHANGE_PROMOTION`,
  addForeingLenguage: `ADD_INTERNATIONAL_TAB`,
  setLoader: `SET_LOADER`,
  addChip: `ADD_CHIP`,
  deleteChip: `DELETE_CHIP`,
  toggleModal: `SHOW_MODAL`,
  rebootState: `CLEAR_STATE`,
  imageChange: `CHANGE_IMAGE`,
  setMainMessage: `MAIN_MESSAGE`,
  rejectAttempt: `REJECT_ATTEMPT`,
  cancelRejectAttempt: `CANCEL_REJECT_ATTEMPT`,
  unlockEdditionForm: `UNLOCK_EDITION_FORM`,
  setExperienceId: `SET_EXPERIENCE_ID`,
  activeTabChange: `ACTIVE_TAB_CHANGE`,
  setRequiredFields: `SET_REQUIRED_FIELDS_ERROR`,
  asyncActions: entity => ({
    start: `REQUEST_${entity.toUpperCase()}_START`,
    success: `REQUEST_${entity.toUpperCase()}_SUCCESS`,
  }),
}

export const requests = {
  validationForm: params => new Request({ endpoint: `getValidationForm`, params }),
  validationFormNationalValidator: params =>
    new Request({ endpoint: `getValidationFormNationalValidator`, params }),
  editForm: params => new Request({ endpoint: `getEditionExperienceForm`, params }),
  upgradeForm: params => new Request({ endpoint: `getExperienceUpgradeForm`, params }),
  validate: data => new Request({ endpoint: `requestValidation`, data }),
  udpate: data => new Request({ endpoint: `updateValidation`, data }),
  rejectExperience: data => new Request({ endpoint: `rejectExperience`, data }),
  approveExperience: data => new Request({ endpoint: `approveExperience`, data }),
  approveExperienceNationalEvaluator: data =>
    new Request({ endpoint: `approveExperienceNationalEvaluator`, data }),
  validationAttempt: data => new Request({ endpoint: `validationAttempt`, data }),
  validatorWatchExperience: params => new Request({ endpoint: `validatorWatchExperience`, params }),
  adminWatchExperience: params => new Request({ endpoint: `adminWatchExperience`, params }),
  providerWatchExperience: params => new Request({ endpoint: `providerWatchExperience`, params }),
  // NEWS
  rejectReasons: () => new Request({ endpoint: `getRejectReasons` }),
  regions: () => new Request({ endpoint: `getRegions` }),
  macrozones: () => new Request({ endpoint: `getMacrozones` }),
  languagesRequest: () => new Request({ endpoint: `getLanguages` }),
  nationalCategories: params => new Request({ endpoint: `nationalCategories`, params }),
  internationalCategories: params => new Request({ endpoint: `internationalCategories`, params }),
  subCategories: params => new Request({ endpoint: `getSubcategories`, params }),
  destinationsByRegion: () => new Request({ endpoint: `destinationsByRegion` }),
  destinationsByZone: () => new Request({ endpoint: `destinationsByZone` }),
  zones: zonesIds =>
    new Request({
      endpoint: `getZones`,
      data: {
        getAll: true,
        zonesIds,
      },
    }),
  destinationsByMacrozone: () => new Request({ endpoint: `destinationsByMacrozone` }),
}

export const requiredEspTabSections = [
  {
    title: `Información básica de la Experiencia`,
    expanded: true,
    disabled: false,
    type: `section`,
    fieldsIds: [`title`, `required_row_1`, `required_row_2`,'required_row_4', `required_row_3`],
  },
]

export const experienceRejectSectionsAndFields = {
  fields: {
    reject_reason: {
      type: `select`,
      value: undefined,
      label: `Selecciona un motivo de rechazo`,
      hidden: false,
      items: [],
      didMount: {
        types: types.asyncActions(`reject_reasons`),
        request: requests.rejectReasons(),
      },
    },
    reject_text: {
      type: `textArea`,
      label: `Escribe un mensaje al proveedor (máx 200 caracteres)`,
      value: undefined,
      tooltip: `Entregar información clara y precisa para que el proveedor pueda completar el formulario de forma correcta`,
      rules: {
        required: true,
        min: 0,
        max: 200,
      },
    },
    reject_form_row: {
      type: `group`,
      fieldsIds: [`reject_reason`, `reject_text`],
    },
  },
  section: {
    title: `Rechazo de experiencia / Opcional`,
    expanded: true,
    disabled: false,
    type: `section`,
    fieldsIds: [`reject_form_row`],
  },
}

export function foreingLanguageTab({ languages, includeEsp = true }) {
  const names = {
    'pt-br': `Information about the experience / Required`,
    it: `Information about the experience / Required`,
    fr: `Information about the experience / Required`,
    de: `Information about the experience / Required`,
    en: `Information about the experience / Required`,
  }
  const tabs = includeEsp ? { es: { ...includeEsp } } : {}
  languages.forEach(abrv => {
    tabs[abrv] = {
      tabName: abrv,
      languageKey: abrv,
      disabled: false,
      tabsSections: [
        {
          title: names[abrv],
          expanded: true,
          disabled: false,
          type: `section`,
          fieldsIds: [`title`, `required_row_1`, `required_row_4`],
        },
      ],
    }
  })
  return tabs
}

export const confirmationModalProps = {
  title: `¿Estás seguro que deseas volver al listado de Experiencias?`,
  titleType: `h2`,
  onCancel: undefined,
  maxWidth: `600px`,
  maxHeight: `auto`,
}

export default {
  requiredEspTabSections,
  foreingLanguageTab,
  requests,
  types,
  confirmationModalProps,
}
